module.exports = __webpack_public_path__ + "img/tips.7e32b1d4.png";